import './styles/graphic.scss';
import './vapor.js';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  const vapor_box = container.append('div')
    .attr('class', 'vapor-calc-sticky')
    .attr('id', 'vapor-graphic');

  const vapor_controls = container.append('div')
    .attr('class', 'vapor-calc-controls');

  vapor_controls.append('div')
    .attr('class', 'button blue selected')
    .attr('data-temp', '0')
    .text('Base');

  vapor_controls.append('div')
    .attr('class', 'button')
    .attr('data-temp', '1')
    .text('+1 grados C');

  vapor_controls.append('div')
    .attr('class', 'button')
    .attr('data-temp', '2')
    .text('+2 grados C');
}
